export const ANNOTATION_THREAD_SCROLL_DURATION_MS = 500;
export const ANNOTATION_THREAD_MAX_ANIMATED_DISTANCE_PX = 480;
export const ANNOTATION_THREAD_AT_BOTTOM_THRESHOLD_PX = 2;

export const getScrollBottomPosition = (element) =>
  element.scrollHeight - element.clientHeight;

export const isScrollAtBottom = ({
  element,
  thresholdPx = ANNOTATION_THREAD_AT_BOTTOM_THRESHOLD_PX,
}) => {
  const maxScrollTop = getScrollBottomPosition(element);
  return maxScrollTop - element.scrollTop <= thresholdPx;
};

export const scrollElementNearBottom = ({
  element,
  maxAnimatedDistancePx = ANNOTATION_THREAD_MAX_ANIMATED_DISTANCE_PX,
}) => {
  const maxScrollTop = getScrollBottomPosition(element);
  const animatedDistance = Math.min(maxAnimatedDistancePx, maxScrollTop);

  element.scrollTop = maxScrollTop - animatedDistance;

  return {
    start: element.scrollTop,
    end: maxScrollTop,
  };
};

export const animateScrollToBottom = ({
  element,
  durationMs = ANNOTATION_THREAD_SCROLL_DURATION_MS,
  onCancelRef = null,
}) => {
  const end = getScrollBottomPosition(element);
  const start = element.scrollTop;
  const distance = end - start;

  const cancel = () => {
    if (frameId != null) {
      cancelAnimationFrame(frameId);
      frameId = null;
    }
  };

  if (distance <= ANNOTATION_THREAD_AT_BOTTOM_THRESHOLD_PX) {
    element.scrollTop = end;
    if (onCancelRef) {
      onCancelRef.current = cancel;
    }
    return cancel;
  }

  let frameId = null;
  const startTime = performance.now();

  const tick = (now) => {
    const progress = Math.min((now - startTime) / durationMs, 1);
    const eased = 1 - Math.pow(1 - progress, 3);
    element.scrollTop = start + distance * eased;

    if (progress < 1) {
      frameId = requestAnimationFrame(tick);
      return;
    }

    element.scrollTop = end;
    frameId = null;
  };

  frameId = requestAnimationFrame(tick);

  if (onCancelRef) {
    onCancelRef.current = cancel;
  }

  return cancel;
};
